import { PermissionByType, PresetsByResourceType } from '@sharefiledev/sharing-pilet-sdk';
import { SharableRelatedResource } from '@sharefiledev/sharing-pilet-sdk/api';
import {
	isConfigurationByResourceType,
	isPermissionMatching,
} from '../Links/ConditionalLinks/utils/linkShare-utils';
import { PermissionsOptionsByType } from '../Share/PermissionSelect';

export const isWildcardPermission = (permission: string) => {
	return permission.startsWith('*:');
};

export const getWildcardMatch = (fullPermission: string) =>
	`*${fullPermission.substring(fullPermission.indexOf(':'))}`;

export const lowerCaseFirstLetter = (label: string) => {
	return label.length === 0 ? label : label.charAt(0).toLowerCase() + label.slice(1);
};

export function getFileExtension(fileName: string, isCaseSensitive = false) {
	return isCaseSensitive
		? fileName.substr(fileName.lastIndexOf('.') + 1)
		: fileName.substr(fileName.lastIndexOf('.') + 1).toLowerCase();
}

export const updateRelatedResourcesStatus = (
	sharableRelatedResources: SharableRelatedResource[] | undefined,
	setSharableRelatedResourcesStatus: React.Dispatch<
		React.SetStateAction<{ [key: string]: boolean }>
	>,
	setRelatedResourcesToShare: React.Dispatch<
		React.SetStateAction<SharableRelatedResource[] | undefined>
	>,
	permissions: string[],
	permissionsOptionsByType?: PermissionsOptionsByType,
	permissionsByType?: PermissionByType,
	presetsByResourceType?: PresetsByResourceType
): void => {
	setSharableRelatedResourcesStatus(prevState => {
		const updatedStatuses = { ...prevState };
		const relatedResources: SharableRelatedResource[] = [];

		sharableRelatedResources?.forEach(relatedResource => {
			let updatedStatus = permissions.some(p =>
				relatedResource?.isRequiredWhenOneOfSelectedPermissions?.includes(p.toString())
			);

			if (isConfigurationByResourceType(permissionsByType, presetsByResourceType)) {
				const isMatching = isPermissionMatching(
					relatedResource,
					permissionsOptionsByType!
				);
				updatedStatus = !!updatedStatus || !!isMatching;
			}

			updatedStatuses[relatedResource.rid] = updatedStatus;

			if (
				relatedResource.required ||
				(relatedResource.isRequiredWhenOneOfSelectedPermissions &&
					relatedResource.isRequiredWhenOneOfSelectedPermissions.length > 0 &&
					updatedStatuses[relatedResource.rid])
			) {
				relatedResources.push(relatedResource);
			}
		});

		setRelatedResourcesToShare(relatedResources);

		return updatedStatuses;
	});
};
